const topics = [
  { label: '#古装剧天花板', count: '23.4万' },
  { label: '#悬疑剧推荐', count: '19.8万' },
  { label: '#甜到齁的爱情剧', count: '17.2万' },
  { label: '#韩剧疯狂安利', count: '15.6万' },
  { label: '#国产剧崛起', count: '14.3万' },
  { label: '#剧荒了求推荐', count: '12.9万' },
  { label: '#熬夜追完的剧', count: '11.5万' },
  { label: '#仙侠剧yyds', count: '10.8万' },
  { label: '#美剧入坑指南', count: '9.6万' },
  { label: '#高分小众剧', count: '8.2万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">追剧圈热议，一起来聊</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <span
              key={topic.label}
              className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 text-foreground-700 text-sm rounded-full hover:bg-accent-100 hover:text-accent-700 transition-colors cursor-pointer"
            >
              {topic.label}
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}